import React from 'react';
import AppContainer from '../app-container';
import LocalizedStrings from '../../localization/strings';
import DocumentTitle from 'react-document-title';

export default class StagesPageContainer extends AppContainer {
    render() {
        return (
            <DocumentTitle title={this.getDocumentTitle(LocalizedStrings.paymentCanceled)}>

                <div className="page-section">
                    <div className="container">
                        <h1 className="title">
                            <span>{LocalizedStrings.paymentCanceled}</span>
                        </h1>
                        <div>
                            {LocalizedStrings.paymentCanceledText}
                        </div>
                    </div>
                </div>
            </DocumentTitle>
        )
    }
}



// WEBPACK FOOTER //
// ./src/js/containers/pages/payment-canceled-page-container.js